import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import PlusCircle from 'components/icons/PlusCircle'
import MinusCircle from 'components/icons/MinusCircle'

import './styles.css'

class ZoomControls extends Component {
  static propTypes = {
    zoomIn: PropTypes.func.isRequired,
    zoomOut: PropTypes.func.isRequired,
  }

  render() {
    const { zoomIn, zoomOut, } = this.props

    return (
      <div className="zoom-controls-container">
        <button
          onClick={() => {
            zoomIn()
          }}
        >
          <PlusCircle customClassName="zoom-in-icon" width={50} />
        </button>
        <button
          onClick={() => {
            zoomOut()
          }}
        >
          <MinusCircle customClassName="zoom-out-icon" width={50} />
        </button>
      </div>
    )
  }
}

export default ZoomControls



// WEBPACK FOOTER //
// ./src/components/ZoomControls/index.js